fragment ProductContext on Product {
    productId: id
    productName: name
    goodOrService: type
    serviceTerm: term
}
